<template>
  <div>
    <vs-table :data="completedOrderList">
      <template slot="thead">
        <vs-th>Stok No</vs-th>
        <vs-th>Toplam Tutar</vs-th>
        <vs-th>Adres Başlık</vs-th>
        <vs-th>Sipariş Tarihi</vs-th>
        <vs-th>Sipariş Durumu</vs-th>
        <vs-th>Ödeme Tipi</vs-th>
        <vs-th>İşlemler</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            {{ data[indextr].pazaryeriKategori }}
          </vs-td>
          <vs-td>
            {{ data[indextr].kategori1Ad }} ->
            {{ data[indextr].kategori2Ad }} ->
            {{ data[indextr].kategori3Ad }} ->
            {{ data[indextr].kategori4Ad }} ->
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
import Store from "../../store/store";
import state from "../../store/state";
export default {
  data() {
    return {
      completedOrderList: [],
    };
  },
  methods: {
    completedOrder() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        cariKod: state.UserId,
      };
      soap.createClient(url, function (err, client) {
        client.bakiyeB2B(args, function (err, result) {
        /*  if (result.bakiyeB2BResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }*/
          vm.veriler = JSON.parse(result.bakiyeB2BResult);
          //   commit('ADD_ITEM_BANK_STATEMENT', vm.veriler)
        });
      });
    },
  },
  created() {
    this.completedOrder();
  },
};
</script>